import { http } from "../httpHandler";
import { links } from "@/constants/links";

export const CALENDARS_GET = "calendars";

export interface CalendarResponse {
  id: string;
  userId: string;
  platform: string;
  externalId: string;
  email: string | null;
  createdAt: number;
  updatedAt: number;
}

export const getAllCalendars = async (): Promise<CalendarResponse[]> => {
  const response = await http.get<CalendarResponse[]>(links.calendar.index);
  return response.data;
};
